import { create } from 'zustand';
import { z } from 'zod';

import { APIEndPoints, Request } from '../apis';
import type { TMerchant } from '../components/types';
import { useMutation } from '@tanstack/react-query';
type TUser = {
  merchant: string;
  userRole: string;
};
type LoggedInUserStoreState = {
  merchant: string;
  userRole: string;
  isLoggedIn: boolean;
  setUser: (user: TUser) => void;
  clearState: () => void;
};

const STARTING_STATE = {
  merchant: 'unknown',
  userRole: 'unknown',
  isLoggedIn: false
} as const;

export const useLoggedInUserStore = create<LoggedInUserStoreState>((set) => ({
  ...STARTING_STATE,
  setUser: ({ merchant, userRole }: TUser) => {
    set({ merchant, userRole, isLoggedIn: true });
  },
  clearState: () => {
    set({ ...STARTING_STATE });
  }
}));

export const clearLoggedInUserStore = () => {
  useLoggedInUserStore.setState({ ...STARTING_STATE });
};

export const storeUserOnLogin = (
  user: TUser,
  setUser: LoggedInUserStoreState['setUser']
) => {
  setUser(user);
};
